import styled, { css } from 'styled-components';
import BootstrapNav from 'react-bootstrap/Nav';
import BootstrapNavbar from 'react-bootstrap/Navbar';
import BootstrapNavDropdown from 'react-bootstrap/NavDropdown';
import theme from '../../theme';

export const Navbar = styled(BootstrapNavbar)`
  background-color: ${theme.colors.dark_blue};
  z-index: 10002;
`;

export const NavLink = styled(BootstrapNav.Link)`
  text-transform: uppercase;
  font-size: 13px;
  border-radius: 5px;
  color: ${theme.colors.white};
  padding: 0.5rem 1rem;
  white-space: nowrap;

  &:hover {
    background-color: rgba(255, 255, 255, 0.15);
    color: ${theme.colors.white};
    text-decoration: none;
  }

  ${({ active }) =>
    active &&
    css`
      background-color: rgba(255, 255, 255, 0.15);
    `}

  @media (max-width: 768px) {
    padding: 1rem 1rem;
  }
`;

export const NavDropdownItem = styled(BootstrapNavDropdown)`
  margin-left: 8px;
  margin-right: 8px;

  > a {
    text-transform: uppercase;
    font-size: 13px;
    border-radius: 5px;
    color: ${theme.colors.black} !important;
    transition: background ease-in 0.3s;

    ${({ active }) =>
      active &&
      css`
        background-color: rgba(255, 255, 255, 0.15);
      `}
    &:hover {
      background-color: rgba(255, 255, 255, 0.15);
      color: ${theme.colors.black};
    }

    @media (max-width: 768px) {
      padding: 1rem;
      padding-left: 1rem;
      padding-right: 1rem;
    }
  }

  .dropdown-menu {
    padding: 0;
    max-height: 100px;
    overflow-y: auto;
    > a {
      text-transform: uppercase;
      font-size: 13px;
      padding: 0.5rem 1rem;
      white-space: pre-wrap;
      &:hover {
        border-radius: 5px;
        color: #3333;
      }
    }
  }
`;

export const NavDropdown = styled(BootstrapNavDropdown)`
  > a {
    text-transform: uppercase;
    font-size: 13px;
    border-radius: 5px;
    color: ${theme.colors.white} !important;
    transition: background ease-in 0.3s;

    ${({ active }) =>
      active &&
      css`
        background-color: rgba(255, 255, 255, 0.15);
      `}
    &:hover {
      background-color: rgba(255, 255, 255, 0.15);
      color: ${theme.colors.white};
    }

    @media (max-width: 768px) {
      padding: 1rem;
      padding-left: 1rem;
      padding-right: 1rem;
    }
  }

  .dropdown-menu {
    padding: 0 0 0.75rem;
    overflow-y: auto;
    max-height: 300px;
    width: max-content;
    max-width: 250px;
    overscroll-behavior: none;

    > a {
      text-transform: uppercase;
      font-size: 13px;
      padding: 0.5rem 1rem;

      &:hover {
        border-radius: 5px;
        color: #3333;
      }
    }
  }
  .dropdown-item {
    white-space: pre-line;
  }
`;

export const NotificationUnreadIcon = styled.div`
  width: 7px;
  height: 7px;
  border-radius: 5px;
  background-color: ${theme.colors.error};
  position: absolute;
  top: 6px;
  right: 6px;
`;

export const DefaultContainer = styled.div`
  display: flex;
  width: 50px;
  position: relative;
  background-color: ${({ theme: themeProvider }) => themeProvider.newTheme.colors.dark_blue};
`;

export const MenuContainer = styled.div`
  background-color: ${({ theme: themeProvider }) => themeProvider.newTheme.colors.dark_blue};
  width: ${({ $isOpen }) => ($isOpen ? '300px' : '60px')};
  padding: ${({ $isOpen }) => ($isOpen ? '12px' : '10px')};
  padding-top: ${({ $isOpen }) => ($isOpen ? '88px' : '72px')};
  color: white;
  position: fixed;
  display: flex;
  flex-direction: column;
  top: 0;
  left: 0;
  z-index: 10000;
  transition: width 0.2s ease;
  border-radius: 0 0 16px 0;
  height: 100vh;
  overflow: hidden;
  box-shadow: ${({ $isOpen }) =>
    $isOpen ? '4px 0 12px rgba(0,0,0,0.15)' : 'none'};

  .dropdown-toggle::after {
    display: none;
  }

  .dropdown-menu {
    position: static;
    float: none;
    transform: none !important;
    background: transparent;
    border: 0;
    box-shadow: none;
    padding: 6px 0 6px 28px;
    margin: 4px 0 0 0;
    max-height: none;
  }

  .dropdown-item {
    color: ${theme.colors.white};
    padding: 6px 8px;
    border-radius: 6px;
  }

  .dropdown-item:hover,
  .dropdown-item:focus,
  .dropdown-item.active {
    color: ${theme.colors.white};
    background: rgba(255, 255, 255, 0.12);
  }
`;

export const ToggleButton = styled.button`
  width: 100%;
  background: transparent;
  color: ${theme.colors.white};
  border: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 8px;
  margin-bottom: 12px;
  cursor: pointer;
  border-radius: 6px;
  transition: background-color 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.12);
  }
`;

export const ScrollArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding-top: 12px;
  padding-right: ${({ $isOpen }) => ($isOpen ? '6px' : 0)};
  padding-bottom: 84px;
  scrollbar-gutter: ${({ $isOpen }) => ($isOpen ? 'stable' : 'auto')};

  scrollbar-width: ${({ $isOpen }) => ($isOpen ? 'thin' : 'none')};
  scrollbar-color: rgba(255, 255, 255, 0.25) transparent;

  &::-webkit-scrollbar {
    width: ${({ $isOpen }) => ($isOpen ? '6px' : 0)};
    height: 0;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.25);
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.4);
  }
`;

export const NotificationReloadBanner = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 3000;
  height: 64px;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 0 18px;
  background: #3f3f3f;
  color: ${theme.colors.white};
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.28);

  span {
    font-size: 20px;
    line-height: 1;
  }

  p {
    margin: 0;
    font-size: 16px;
    line-height: 1.3;
  }

  button {
    min-height: 40px;
    padding: 0 18px;
    border: 0;
    border-radius: 22px;
    background: #a9c7ff;
    color: #123d74;
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
  }
`;

export const OneSignalNotificationControl = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 10001;
  width: ${({ $isOpen }) => ($isOpen ? '300px' : '60px')};
  height: 62px;
  display: flex;
  align-items: center;
  padding-left: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.18);
  background-color: ${({ theme: themeProvider }) => themeProvider.newTheme.colors.dark_blue};
  transition: width 0.2s ease;

  .notification-bell {
    width: clamp(26px, 2vw, 32px);
    height: clamp(26px, 2vw, 32px);
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid ${theme.colors.white};
    border-radius: 50%;
    background: #c9414a;
    color: ${theme.colors.white};
    box-shadow:
      0 0 0 2px rgba(233, 75, 75, 0.28),
      0 2px 5px rgba(0, 0, 0, 0.24);
    cursor: pointer;
    opacity: 0.72;
    transition: background-color 0.15s, box-shadow 0.15s, opacity 0.15s;
  }

  .notification-bell svg {
    width: clamp(12px, 1vw, 16px);
    height: clamp(12px, 1vw, 16px);
  }

  .notification-bell:hover {
    background: #ff5a63;
    box-shadow:
      0 0 0 2px rgba(255, 90, 99, 0.24),
      0 2px 7px rgba(0, 0, 0, 0.28);
    opacity: 1;
  }

  .notification-bell:hover + .notification-tooltip {
    opacity: 1;
    visibility: visible;
  }

  .notification-tooltip {
    position: absolute;
    left: clamp(36px, 2.7vw, 42px);
    bottom: clamp(16px, 1.2vw, 18px);
    width: max-content;
    max-width: 260px;
    padding: 8px 10px;
    border-radius: 5px;
    background: #000;
    color: ${theme.colors.white};
    font-size: 12px;
    line-height: 1.2;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.15s;
    pointer-events: none;
  }

  .notification-tooltip.is-visible {
    opacity: 1;
    visibility: visible;
  }

  .notification-tooltip::before {
    content: '';
    position: absolute;
    left: -5px;
    bottom: 9px;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-right: 5px solid #000;
  }

  .notification-popover {
    position: absolute;
    left: 8px;
    bottom: clamp(48px, 3.7vw, 54px);
    width: 204px;
    border: 1px solid #dddddd;
    border-radius: 4px;
    background: ${theme.colors.white};
    color: #5d1717;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.16);
  }

  .notification-popover::before {
    content: '';
    position: absolute;
    left: 10px;
    bottom: -8px;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #dddddd;
  }

  .notification-popover::after {
    content: '';
    position: absolute;
    left: 11px;
    bottom: -7px;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 7px solid ${theme.colors.white};
  }

  .notification-popover h3 {
    margin: 0;
    padding: 12px 14px;
    border-bottom: 1px solid #eeeeee;
    font-size: 13px;
    font-weight: 500;
    color: #5d1717;
  }

  .notification-popover p {
    margin: 0;
    padding: 12px 12px 6px;
    color: #333333;
    font-size: 12px;
    line-height: 1.45;
  }

  .notification-preview {
    display: flex;
    gap: 7px;
    margin: 8px 10px 8px;
    padding: 6px;
    border: 1px solid #eeeeee;
  }

  .notification-preview > span {
    width: 44px;
    height: 40px;
    background: #dddddd;
  }

  .notification-preview > div {
    flex: 1;
    padding-top: 3px;
  }

  .notification-preview i {
    display: block;
    height: 4px;
    margin-bottom: 5px;
    background: #dddddd;
  }

  .notification-preview i:nth-child(1) {
    width: 78%;
  }

  .notification-preview i:nth-child(2) {
    width: 92%;
  }

  .notification-preview i:nth-child(3) {
    width: 80%;
  }

  .notification-preview i:nth-child(4) {
    width: 66%;
  }

  .notification-action {
    width: calc(100% - 20px);
    min-height: 30px;
    margin: 0 10px 10px;
    border: 0;
    border-radius: 3px;
    background: #e94b4b;
    color: ${theme.colors.white};
    cursor: pointer;
    font-size: 12px;
  }

  .permission-preview {
    display: block;
    width: calc(100% - 24px);
    margin: 6px 12px 16px;
    cursor: pointer;
  }

  .permission-preview img {
    display: block;
    width: 100%;
    border: 1px solid #dddddd;
  }
`;

export const BackDrop = styled.div`
  background-color: ${({ theme: themeProvider }) => themeProvider.newTheme.colors.dark_blue};
  width: 50px;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
`;

export const VersionUnreadIcon = styled.div`
  width: 7px;
  height: 7px;
  border-radius: 5px;
  background-color: ${theme.colors.error};
  position: absolute;
  top: 6px;
  right: 6px;
`;
